// extracted by mini-css-extract-plugin
export var wrapper = "landing-list-module--wrapper--qmKp7";
export var list = "landing-list-module--list--WDSYX";
export var listLength3 = "landing-list-module--list-length-3--e2H7E";
export var listLength4 = "landing-list-module--list-length-4--PObBP";
export var description = "landing-list-module--description---1dw9";